// External dependencies
import { useTranslation } from 'react-i18next';
import React from 'react';

// Internal dependencies
import LanguageSwitch from '@/modules/core/client/components/LanguageSwitch';

export default function NavigationLoggedOut({
  currentPath,
}: {
  currentPath: string;
}) {
  const { t } = useTranslation('core');

  return (
    <div className="container w-100">
      <nav
        aria-label={t('Page navigation')}
        className="header-welcome text-center"
        role="navigation"
      >
        {/* a span for centering the main header content */}
        <span className="flex-side"></span>
        <span className="header-welcome-text hidden-xs" dir="auto">
          {t('New to Trustroots?')}
        </span>
        <a href="/signup" className="btn btn-lg btn-default">
          {t('Join')}
        </a>
        <a href="/signin" className="btn btn-lg btn-inverse">
          {t('Login')}
        </a>
        {currentPath !== '/' && (
          <a
            aria-label={t('Read more about Trustroots')}
            className="btn btn-link header-more-text hidden-xs"
            href="/"
          >
            {t('Read more')}
          </a>
        )}
        <div className="flex-side language-switch">
          <LanguageSwitch buttonStyle="inverse" />
        </div>
      </nav>
    </div>
  );
}
